// extracted by mini-css-extract-plugin
module.exports = {"otpContainer":"mfaEmailSetupModal_otpContainer__2o6tA","otpInput":"mfaEmailSetupModal_otpInput__185H5","btnDisabled":"mfaEmailSetupModal_btnDisabled__2uvVY"};